module.exports = function(app) {
	app.directive('ngEnter', ngEnter);
	ngEnter.$inject=[];
	function ngEnter() {
		return {
			link: function (scope, element, attrs) {
	            element.unbind("keydown keypress").bind("keydown keypress", function (event) {
	                if (event.which === 13) {
	                    scope.$apply(function () {
	                        scope.$eval(attrs.ngEnter);
	                    });
	                    event.preventDefault();
	                }
				});
				scope.$on('$destroy', function() {
					element.unbind("keydown keypress");
				})
	        }
	    }
	}	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/ngEnterDirective.js
// module id = 442
// module chunks = 0